import {Injectable} from '@angular/core';
import {getLocalStorage, isStorageSupported} from '../../../pollyfills/storagePolyfill';

declare let window: Window;

@Injectable()
export class LocalStorageService implements Storage {
    protected localStorage: Storage;

    constructor() {
        this.setStorage();
    }

    protected setStorage() {
        this.localStorage = getLocalStorage(window);
        console.debug(`[LocalStorageService] polyfill ${isStorageSupported() ? 'disabled' : 'enabled'}`);
    }

    get length(): number {
        return this.localStorage.length;
    }

    getItem(key: string): string | null {
        return this.localStorage.getItem(key);
    }

    setItem(key: string, value: string) {
        return this.localStorage.setItem(key, value);
    }

    clear(): void {
        return this.localStorage.clear();
    }

    key(index: number): string | null {
        return null;
    }

    removeItem(key: string): void {
        return this.localStorage.removeItem(key);
    }

    getJson(key: string): any[] | Record<string, any> | null {
        try {
            return JSON.parse(this.getItem(key));
        } catch (e) {
            console.debug('[LocalStorageService] getJson error', e);
            return null;
        }
    }
}
